<div>
    <!--Form3 Login Start-->


    <!--Form3 Login End-->
    <!--Form3 IF Start-->

    <div class="card m-3">
        <h5 class="card-header" style="font-size: 21px">
            Exam Related Issue
        </h5>
        <div class="card-body">
            <form *ngIf="criform_bool" [formGroup]="criForm" (ngSubmit)="oncriSubmit()">
                <div class="form-row">

                    <h2 *ngIf="show_msg_bool"
                        style="background: red; color: #fff; padding: 5px 15px; width: 100%; border-radius: 5px; font-size: 16px;">
                        YOU
                        ALREADY CREATE GRIVENCE
                    </h2>



                    <div class="form-group col-3">
                        <label>Email </label>

                        <input type="text" formControlName="email" class="form-control" [(ngModel)]="mail_single"
                            [attr.disabled]="true" [ngClass]="{
                                'is-invalid': submitted && cri.email.errors
                              }" />

                        <div *ngIf="submitted && cri.email.errors" class="invalid-feedback">
                            <div *ngIf="cri.email.errors.required">
                                Email is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-3">
                        <label>State</label>

                        <input type="text" formControlName="state" class="form-control" [(ngModel)]="state_single"
                            [attr.disabled]="true" [ngClass]="{'is-invalid': submitted && cri.state.errors}" />

                        <div *ngIf="submitted && cri.state.errors" class="invalid-feedback">
                            <div *ngIf="cri.state.errors.required">
                                state is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-3">
                        <label>District</label>

                        <input type="text" formControlName="district" class="form-control" [(ngModel)]="district_single"
                            [attr.disabled]="true" [ngClass]="{'is-invalid': submitted && cri.district.errors}" />

                        <div *ngIf="submitted && cri.district.errors" class="invalid-feedback">
                            <div *ngIf="cri.district.errors.required">
                                district is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-3">
                        <label>ITI Code</label>
                        <input type="text" formControlName="iticode" class="form-control" [(ngModel)]="iticode_single"
                            [attr.disabled]="true" [ngClass]="{'is-invalid': submitted && cri.iticode.errors}" />

                        <div *ngIf="submitted && cri.iticode.errors" class="invalid-feedback">
                            <div *ngIf="cri.iticode.errors.required">
                                iti code is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-3">
                        <label>Trade</label>

                        <input type="text" formControlName="trade" class="form-control" [(ngModel)]="trade_single"
                            [attr.disabled]="true" [ngClass]="{'is-invalid': submitted && cri.trade.errors}" />

                        <!-- <select formControlName="trade" class="form-control" (change)="tradeChange($event)" [ngClass]="{
                  'is-invalid': submitted && cri.trade.errors
                }">
                            <option [selected]="true" value="undefined" disabled="true">
                                Please Select Trade
                            </option>
                            <option *ngFor="let trad of trade_single" [value]="trad.trade">
                                {{ trad.trade }}
                            </option>
                        </select> -->
                        <div *ngIf="submitted && cri.trade.errors" class="invalid-feedback">
                            <div *ngIf="cri.trade.errors.required">
                                trade is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-3">
                        <label> Register No</label>
                        <input type="text" formControlName="regno" class="form-control" [(ngModel)]="regno_single"
                            [attr.disabled]="true" [ngClass]="{'is-invalid': submitted && cri.regno.errors}" />

                        <div *ngIf="submitted && cri.regno.errors" class="invalid-feedback">
                            <div *ngIf="cri.regno.errors.required">
                                regno is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-3">
                        <label>Student Name</label>

                        <input type="text" formControlName="username" class="form-control" [(ngModel)]="cri_username"
                            [attr.disabled]="true" [ngClass]="{
                  'is-invalid': submitted && cri.username.errors
                }" />

                        <div *ngIf="submitted && cri.username.errors" class="invalid-feedback">
                            <div *ngIf="cri.username.errors.required">
                                username is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-3">
                        <label>Exam Date</label>

                        <input type="text" formControlName="date" class="form-control" [(ngModel)]="cri_examdate"
                            [attr.disabled]="true" [ngClass]="{
                  'is-invalid': submitted && cri.date.errors
                }" />

                        <div *ngIf="submitted && cri.date.errors" class="invalid-feedback">
                            <div *ngIf="cri.date.errors.required">date is required</div>
                        </div>
                    </div>

                    <div class="form-group col-3">
                        <label>Shift</label>

                        <input type="text" formControlName="shift" class="form-control" [(ngModel)]="cri_shift"
                            [attr.disabled]="true" [ngClass]="{
                  'is-invalid': submitted && cri.shift.errors
                }" />

                        <div *ngIf="submitted && cri.shift.errors" class="invalid-feedback">
                            <div *ngIf="cri.shift.errors.required">
                                shift is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-9">
                        <label>Attendance</label>

                        <input type="text" formControlName="attendance" class="form-control"
                            [(ngModel)]="cri_attendance" [attr.disabled]="true" [ngClass]="{
                  'is-invalid': submitted && cri.attendance.errors
                }" />

                        <div *ngIf="submitted && cri.attendance.errors" class="invalid-feedback">
                            <div *ngIf="cri.attendance.errors.required">
                                attendance is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-3">
                        <label>Exam Status</label>

                        <input type="text" formControlName="status" class="form-control" [(ngModel)]="cri_examstatus"
                            [attr.disabled]="true" [ngClass]="{
                  'is-invalid': submitted && cri.status.errors
                }" />

                        <div *ngIf="submitted && cri.status.errors" class="invalid-feedback">
                            <div *ngIf="cri.status.errors.required">
                                status is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-9">
                        <label>Center</label>

                        <input type="text" formControlName="center" class="form-control" [(ngModel)]="cri_cenername"
                            [attr.disabled]="true" [ngClass]="{
                  'is-invalid': submitted && cri.center.errors
                }" />

                        <div *ngIf="submitted && cri.center.errors" class="invalid-feedback">
                            <div *ngIf="cri.center.errors.required">
                                center is required
                            </div>
                        </div>
                    </div>


                    <hr>

                    <div class="form-group col-3">
                        <label>Invigilator name</label>


                        <select class="form-control" formControlName="invigilatorname" class="form-control"
                            (change)="tradeChange($event)" [ngClass]="{
                            'is-invalid': submitted && cri.invigilatorname.errors
                          }">
                            <option [selected]="true" value="undefined" disabled="true">
                                Please Select Trade
                            </option>
                            <option *ngFor="let trad of invigilator_name" [value]="trad.name">
                                {{ trad.name }}
                            </option>
                        </select>

                        <input type="hidden" formControlName="invigEmail" class="form-control"
                            [(ngModel)]="cri_invigemail" [attr.disabled]="true" />

                        <div *ngIf="submitted && cri.invigilatorname.errors" class="invalid-feedback">
                            <div *ngIf="cri.invigilatorname.errors.required">
                                Invigilator name is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-4" *ngIf="ntefmain_bool">
                        <label>Nature of Technical Issue Faced</label>

                        <select class="form-control" (change)="ntefonChange($event)" placeholder="test"
                            formControlName="ntef" [ngClass]="{
                'is-invalid': submitted && cri.ntef.errors
              }">
                            <option [selected]="true" value="undefined" disabled="true">
                                Please Select
                            </option>
                            <option *ngFor="let ntef of NTEF" [value]="ntef.name">
                                {{ ntef.name }}
                            </option>
                        </select>

                        <div *ngIf="submitted && cri.ntef.errors" class="invalid-feedback">
                            <div *ngIf="cri.ntef.errors.required">
                                ntef is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-4" *ngIf="ntefsub_bool">
                        <label>Issue Detail</label>

                        <select id="sel1" class="form-control" formControlName="issuedetail" [ngClass]="{
                'is-invalid': submitted && cri.issuedetail.errors
              }">
                            <option [selected]="true" value="undefined" disabled="true">
                                Please Select
                            </option>
                            <option *ngFor="let ntefsubs of ntefSub" [value]="ntefsubs">
                                {{ ntefsubs }}
                            </option>
                        </select>

                        <div *ngIf="submitted && cri.issuedetail.errors" class="invalid-feedback">
                            <div *ngIf="cri.issuedetail.errors.required">
                                issue detail is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-12" *ngIf="ntefdesc_bool">
                        <label>Description of the other issue</label>

                        <textarea formControlName="description" class="form-control" formControlName="description"
                            [ngClass]="{
              'is-invalid': submitted && cri.description.errors
            }" rows="3" (keypress)="omit_spl($event)" maxlength="500" style="resize: none;"></textarea>
                        <!-- <input type="text" formControlName="description" class="form-control"
                            formControlName="description" [ngClass]="{
                  'is-invalid': submitted && cri.description.errors
                }" /> -->

                        <div *ngIf="submitted && cri.description.errors" class="invalid-feedback">
                            <div *ngIf="cri.description.errors.required">
                                description is required
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-12">
                        <div class="text-center">
                            <button class="btn btn-primary mr-1" [disabled]="submit_btn_bool">Submit</button>
                        </div>
                    </div>
                </div>
            </form>

            <div class="eriformr_res_cls" *ngIf="criform_status_bool">
                <p>Your Complaint has been Successfully Registered. </p>
                <p>Your CRI Ticket ID is <b> {{cri_genrateid}} </b> </p>
                <p>A Confirmation Email has been sent to your Registered Email Id <b>{{cri_email}}</b> </p>
                <p>The Status of your Complaint can be Tracked at <button (click)="back_fn()" class="track_btn_cls"
                        routerLink="/candidatedashboard/criview">Track Your complaint </button> </p>
                <p> <button class="track_btn_cls" (click)="back_fn()">Back</button> </p>
            </div>

        </div>
    </div>
    <!--Form3 IF close-->
</div>